import * as toggles from "../searchdiscover/toggles";
import * as ShopFlavor from "shared/src/utils/ShopFlavor";

export function shouldShowMetroXStoreSelector(): boolean {
    return (
        (toggles.showMetroXStoreSelectorFSD() && ShopFlavor.isFsdShop()) ||
        (toggles.showMetroXStoreSelectorCCOV() && ShopFlavor.isStoreShop())
    );
}
